<template lang="pug">
.bodoan-answer
  .bodoan-answer-form
    .bodoan-answer-form-games
      .og--generator.bodoan(v-for="poll in polls")
        .og--generator-item
          .og--generator-actions(v-if="poll.answerId")
            .og--generator-actions-x(@click="postImage(poll)")
              span ポスト!!
          .og--generator-actions(v-else)
            .og--generator-actions-x.disabled
              span 未回答
          .og--generator-card.bodoan-card(:data-target='poll.className' v-bind:class='poll.className')
            .og--generator-card-title
              .og--generator-card-title-text {{poll.categoryName}}ボードゲーム
            .og--generator-card-content.games.bodoan-content
              .og--generator-card-content-games-editor
                .og--generator-card-content-games-editor-result(@click='openSearchForm(poll)')
                  .og--generator-card-content-games-editor-result-blank
                    .og--generator-card-content-games-editor-result-item.blank 選択する
                    .og--generator-card-content-games-editor-result-item.blank 選択する
                    .og--generator-card-content-games-editor-result-item.blank 選択する
                  .og--generator-card-content-games-editor-result-selected
                    .og--generator-card-content-games-editor-result-item.selected(v-for="game in poll.answeredGames")
                      img(:src="game.public_image_path")
                      p
                        span {{game.name}}
                      .hidden(:data-game-id="game.id")
    .bodoan-answer-form-x-account(v-if="!userId")
      label.bodoan-answer-form-x-account-label.col-lg-3.col-md-3.col-sm-3.col-xs-12
        | Xアカウント名
      .bodoan-answer-form-x-account-input.col-lg-8.col-md-8.col-sm-8.col-xs-12
        | @
        input.form-control(type="text" placeholder="Xアカウントを入力してください" v-model="answer.xAccountId")
  .bodoan-answer-submit
    button.btn.btn-primary.bodoan-answer-submit-button(v-on:click="onSubmit" :disabled="submitting") 上記の内容で回答する
  .bodoan-answer-alert
    .alert.alert-danger(v-if="errorMessage")
      | {{ errorMessage }}
    .alert.alert-success(v-if="successMessage")
      | {{ successMessage }}

</template>

<script>
import axios from 'axios';
import html2canvas from '../../../assets/javascripts/html2canvas.js';

export default {
  props: {
    polls: {
      type: Array,
      default: () => []
    },
    successMessage: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    },
    answer: {
      type: Object,
      default: () => {}
    },
    submitting: {
      type: Boolean,
      default: false
    },
    nameUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    openSearchForm: function(poll) {
      this.$emit('open-search-form', poll);
    },
    onSubmit: function() {
      this.$emit('submit');
    },
    postImage: function(poll) {
      var loadingElement = document.getElementById('loading');
      loadingElement.style.display = 'block';

      html2canvas(
        document.querySelectorAll(`[data-target=${poll.className}]`)[0],
        { scale: 3, proxy: true, useCORS: true, }
      ).then((canvas) => {
        var imgData = canvas.toDataURL();
        var data = { answer: { image: imgData } };
        axios.put(`/bodoans/${this.nameUrl}/answers/${poll.answerId}/update_image.json`, data).then(response => {
          var url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(response.data.share_text)}&url=${encodeURIComponent(response.data.share_url)}`;
          loadingElement.style.display = 'none';
          window.location.href = url;
        }).catch(() => {
          // NOTE: エラー時にスタイル・テキストを指定してメッセージを表示し、リロードさせる
          loadingElement.style.color = '#F00';
          loadingElement.style.paddingTop = '150px';
          loadingElement.style.backgroundImage = 'none';
          loadingElement.style.textAlign = 'center';
          loadingElement.textContent = '画像の生成に失敗しました。再読み込みを行います。';
          setTimeout(function() {
            window.location.reload();
          }, 300);
        });
      });
    }
  },
};
</script>

<style scoped lang="scss">
@import "app/assets/stylesheets/_mixin.scss";
@import "app/assets/stylesheets/_variable.scss";

.og--generator-card-content.games.bodoan-content {
  @include responsive(sm) { padding-top: 30px; }
  @include responsive(xs) { padding-top: 20px; }
}
.bodoan-answer {
  display: block;
  .bodoan-answer-form {
    &-games {
      .og--generator.bodoan {
        @include responsive(sm) { min-width: 100%; }
        .og--generator-item {
          @include responsive(sm) {
            margin: 0 auto;
            display: flex;
          }
          .og--generator-actions {
            @include responsive(sm) {
              margin: auto 15px;
            }
          }
          .og--generator-card.bodoan-card {
            .og--generator-card-title {
              .og--generator-card-title-text {
                @include responsive(xs) { font-size: 14px; }
              }
            }
          }
        }
      }
    }
    &-x-account {
      width: 90%;
      padding: 20px 0;
      margin: 10px auto;
      &-label {
        margin-top: 10px;
        @include responsive(sm) { margin-left: 30px; }
        @include responsive(xs) { margin: 5px }
      }
      &-input {
        display: flex;
        align-items: center;
      }
    }
  }
  .bodoan-answer-submit {
    display: block;
    padding: 10px 0;
    .bodoan-answer-submit-button {
      display: block;
      margin: 0 auto;
      padding: 10px;
      width: 90%;
    }
  }
  .bodoan-answer-alert {
    width: 90%;
    margin: 10px auto;
    .alert {
      text-align: center;
      white-space: pre-wrap;
    }
  }
}

</style>
